export default __webpack_public_path__ + "static/media/16_9-card.e4bd688a.png";